var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$dav.isTotem)?_c('totem-sign-in'):_c('default-sign-in')
}
var staticRenderFns = []

export { render, staticRenderFns }